import React from 'react'
import { Box, Typography, Divider, Button, Paper } from '@mui/material';
import Modal from '@mui/material/Modal';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Unstable_Grid2/Grid2';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Container from '@mui/material/Container';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import { COLUMNASDOCUMENTOSGARANTIA } from '../../columnas/ColumnasDocumentosGarantia'
import Tabla from '../Tabla';
import ModalNuevoAdjuntoG from './ModalNuevoAdjuntoG';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Tooltip from '@mui/material/Tooltip';
import { useTheme } from '@mui/material/styles';

const ModalGarantias = ({ open, handleClose, adjuntos, garantia, garantiaid }) => {
    const [value, setValue] = React.useState("0")
    const [openNew, setOpenNew] = React.useState(false)
    const theme = useTheme();
    const handleChangeTabs = (event, newValue) => {
        setValue(newValue)
    }

    let dollarUS = Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
    });

    const handleOpenNew = () => {
        setOpenNew(true)
    }

    const handleCloseNew = () => setOpenNew(false);

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            maxWidth="lg"
        >
            <DialogContent sx={{ m: 0, p: 0 }}>
                {/* <Box sx={style}> */}
                <Paper elevation={2} sx={{ m: 0, p: 0 }}>
                    <Box sx={{ display: "flex", justifyContent: "space-between", p: 1 }}>
                        <Typography id="alert-dialog-title" sx={{ fontSize: "1.2rem", pt: 1 }}>
                            Garantias
                        </Typography>
                        <Tooltip title={<Typography sx={{ color: '#fff' }}>Cerrar</Typography>}>
                            <IconButton
                                edge="end"
                                color="warning"
                                onClick={handleClose}
                                aria-label="close"
                                sx={{ mr: 2 }}
                            >
                                <CloseIcon />
                            </IconButton>
                        </Tooltip>
                    </Box>
                    {/* <Typography id="modal-modal-title" variant="h6" component="h2" sx={{ p: 2 }}>
                        Garantias
                    </Typography> */}
                    <Divider />
                    <Container component="main">
                        <TabContext value={value}>
                            <Box sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                // bgcolor: 'background.paper'
                            }}>
                                <TabList
                                    aria-label="scrollable force tabs example"
                                    onChange={handleChangeTabs} variant="scrollable"
                                    scrollButtons="auto"
                                    allowScrollButtonsMobile
                                >
                                    <Tab label="General" value="0" sx={{ fontWeight: 'bold', fontSize: '16px', color: theme.typography.primary.text }}></Tab>
                                    <Tab label="Adjuntos" value="1" sx={{ fontWeight: 'bold', fontSize: '16px', color: theme.typography.primary.text }}></Tab>
                                    {/* <Tab label="Plan de Cuotas" value="2"></Tab>
                                    <Tab label="Monetización y Ponderación" value="3"></Tab> */}
                                </TabList>
                            </Box>
                            <TabPanel value="0" sx={{ p: 0, mt: 1, height: '400px', overflow: 'auto' }}>
                                {
                                    garantia.map(gar =>
                                        <Grid container>
                                            <Grid xs={6} sx={{ p: 1 }}>
                                                <TextField fullWidth label="N° de Orden" variant="standard" value={gar.new_ndeordendelagarantiaotorgada ? gar.new_ndeordendelagarantiaotorgada : '-'} />
                                            </Grid>
                                            <Grid xs={6} sx={{ p: 1 }}>
                                                <TextField fullWidth label="Tipo de Operación" variant="standard" value={gar.new_tipodeoperacion ? gar.new_tipodeoperacion : '-'} />
                                            </Grid>
                                            <Grid xs={6} sx={{ p: 1 }}>
                                                <TextField fullWidth label="Formato del Cheque" variant="standard" value={gar.new_formatodelcheque ? gar.new_formatodelcheque : '-'} />
                                            </Grid>
                                            <Grid xs={6} sx={{ p: 1 }}>
                                                <TextField fullWidth label="Nro de Cheque" variant="standard" value={gar.new_numerodecheque ? gar.new_numerodecheque : '-'} />
                                            </Grid>
                                            <Grid xs={6} sx={{ p: 1 }}>
                                                <TextField fullWidth label="Tipo CHPD" variant="standard" value={gar.new_tipochpd ? gar.new_tipochpd : '-'} />
                                            </Grid>
                                            <Grid xs={6} sx={{ p: 1 }}>
                                                <TextField fullWidth label="Librador" variant="standard" value={gar.new_librador ? gar.new_librador : '-'} />
                                            </Grid>
                                            <Grid xs={6} sx={{ p: 1 }}>
                                                <TextField fullWidth label="Tipo de Garantía" variant="standard" value={gar.new_tipodegarantias ? gar.new_tipodegarantias : '-'} />
                                            </Grid>
                                            <Grid xs={6} sx={{ p: 1 }}>
                                                <TextField fullWidth label="Fecha de Carga" variant="standard" value={gar.createdon ? gar.createdon : '-'} />
                                            </Grid>
                                            <Grid xs={6} sx={{ p: 1 }}>
                                                <TextField fullWidth label="Fecha de Vencimiento" variant="standard" value={gar.new_fechadevencimiento ? gar.new_fechadevencimiento : '-'} />
                                            </Grid>
                                            <Grid xs={6} sx={{ p: 1 }}>
                                                <TextField fullWidth label="Monto Bruto" variant="standard" value={gar.new_monto ? dollarUS.format(gar.new_monto) : '-'} />
                                            </Grid>
                                            <Grid xs={6} sx={{ p: 1 }}>
                                                <TextField fullWidth label="Divisa" variant="standard" value={gar.transactioncurrencyid ? gar.transactioncurrencyid : '-'} />
                                            </Grid>
                                            <Grid xs={6} sx={{ p: 1 }}>
                                                <TextField fullWidth label="Estado de la Garantía" variant="standard" value={gar.statuscode_value ? gar.statuscode_value : '-'} />
                                            </Grid>
                                            <Grid xs={6} sx={{ p: 1 }}>
                                                <TextField fullWidth label="Acreedor" variant="standard" value={gar.new_acreedor ? gar.new_acreedor : '-'} />
                                            </Grid>
                                            <Grid xs={6} sx={{ p: 1 }}>
                                                <TextField fullWidth label="Tasa" variant="standard" value={gar.new_tasa ? gar.new_tasa : '-'} />
                                            </Grid>
                                            <Grid xs={6} sx={{ p: 1 }}>
                                                <TextField fullWidth label="Plazo en Meses" variant="standard" value={gar.new_plazodias ? gar.new_plazodias : '-'} />
                                            </Grid>
                                            <Grid xs={6} sx={{ p: 1 }}>
                                                <TextField fullWidth label="Plazo de Gracia en Meses" variant="standard" value={gar.new_periodogracia ? gar.new_periodogracia : '-'} />
                                            </Grid>
                                            <Grid xs={6} sx={{ p: 1 }}>
                                                <TextField fullWidth label="Sistema de Amortización" variant="standard" value={gar.new_sistemadeamortizacion ? gar.new_sistemadeamortizacion : '-'} />
                                            </Grid>
                                            <Grid xs={6} sx={{ p: 1 }}>
                                                <TextField fullWidth label="Periocidad de Pago" variant="standard" value={gar.new_periodicidadpagos ? gar.new_periodicidadpagos : '-'} />
                                            </Grid>
                                            <Grid xs={6} sx={{ p: 1 }}>
                                                <TextField fullWidth multiline label="Observaciones" variant="standard" value={gar.new_observaciones ? gar.new_observaciones : '-'} />
                                            </Grid>
                                        </Grid>
                                    )
                                }
                            </ TabPanel>
                            <TabPanel value="1" sx={{ p: 0, mt: 1, height: '400px', overflow: 'auto' }}>
                                <Grid container>
                                    <Tabla
                                        lineas={adjuntos}
                                        columnas={COLUMNASDOCUMENTOSGARANTIA}
                                        handleOpenNew={handleOpenNew}
                                        accionAgregar={true}
                                    />
                                </Grid>
                            </ TabPanel>
                            <ModalNuevoAdjuntoG open={openNew} handleClose={handleCloseNew} garantiaid={garantiaid} />
                        </TabContext>
                    </Container>
                </Paper>
            </DialogContent>
            {/* </Box> */}
        </Dialog >
    )
}

export default ModalGarantias